module.exports = __webpack_public_path__ + "img/it.668606c.webp";